import * as Yup from 'yup';

export const validationSchema = Yup.object({
    link: Yup.string()
        .matches(
            /^https:\/\/t\.me\/[a-zA-Z0-9_]{5,32}$/,
            'Ссылка должна быть вида https://t.me/username'
        )
        .required('Поле обязательно'),
});
